import { flagFactory } from '../icon';
import Svg from './ie.svg';

export default flagFactory(Svg);
